import useAttributeObserver from './useAttributeObserver'
export default useAttributeObserver
